// Helper function to get a cookie value by name
export function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split('; ').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = value;
    return acc;
  }, {});

  return cookies[name];
}

// Helper function to check if user is authenticated
export function isAuthenticated() {
  return !!getCookie('authToken');
}

// Helper function to redirect to login with current page as redirect
export function redirectToLogin(router, currentPath) {
  router.push({
    path: '/login',
    query: {
      redirect: currentPath
    }
  });
}